<evc-input
  type="text"
  class="search__input"
  autocomplete="off"
  [placeholder]="placeholder() ?? ('search' | platformTranslate)()"
  [clearable]="true"
  [ngModel]="searchText$ | async"
  (ngModelChange)="onSearchTextChanged($event)"
  (keyup)="searchMe($event)">
  <evc-icon
    left
    class="icon"
    icon="search"
    size="xs" />
</evc-input>
